export default function GetCookieByName(cookiename) {
    const cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        const eqIdx = cookieArr[i].indexOf("=");
        if (eqIdx === -1) continue;
        const name = cookieArr[i].slice(0, eqIdx).trim();
        if (name === cookiename) {
            const raw = cookieArr[i].slice(eqIdx + 1).trim();
            if (raw && raw !== "undefined") {
                try {
                    return decodeURIComponent(raw);
                } catch {
                    return raw;
                }
            }
        }
    }
    return {};
}